export const presenceBoolean = (value: unknown, inputLabel: string): boolean => {
  if (value === true || value === false) {
    return value;
  }

  if (value === '') {
    return true;
  }

  if (value == null) {
    return false;
  }

  throw new Error(`${inputLabel} expects a boolean, got: ${String(value)}`);
};
